export default () => {

    const forms = document.querySelectorAll('[data-mailchimp]');
    for (const form of forms) {
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            const button = form.querySelector('button');
            const data = new FormData(form);

            button.innerText = 'Please wait...';

            const xhr = new XMLHttpRequest();
            xhr.open('POST', form.getAttribute('action'));
            xhr.onload = () => {
                if (xhr.status === 200) {
                    button.innerText = 'Subscribe';
                    form.reset();

                    const message = document.createElement('DIV');
                    message.innerHTML = '<i>Subscribed!</i>';
                    button.parentNode.append(message);

                }
            }
            xhr.send(data);
            return false;
        })
    }

}
